import { apiSlice } from "../api/apiSlice";

export const dialogsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProgress: builder.query({
      query: () => `/my/progress`,
      providesTags: (result, error, arg) => [{ type: "Progress" }],
    }),
  }),
});

export const { useGetProgressQuery } = dialogsSlice;
